<template>
  <v-layout>
    <v-flex >
      <panel :title="bolus.imei">
        <v-form ref="form">
        <v-text-field
          :label="$t('bolusGenerics.bolusName')"
          v-model="bolus.bolus_name"
        ></v-text-field>

        <v-text-field
          label="Imei"
          required
          v-model="bolus.imei"
        ></v-text-field>

        <v-text-field
          label="Imsi"
          required
          v-model="bolus.imsi"
        ></v-text-field>

        <v-text-field
          :label="$t('bolusGenerics.deveui')"
          required
          v-model="bolus.deveui"
        ></v-text-field>

        <date-time-picker-with-zone
          @dateChanged="newDate => (bolus.activation_date = $moment(newDate))"
          :label="$t('bolusGenerics.activationDate')+':'"
          :actDate="bolus.activation_date"
        />

        <v-checkbox v-model="bolus.is_ph" :label="$t('bolusGenerics.isPh')"></v-checkbox>

        <h3 v-if="bolus.is_ph" class="ph-title">{{$t('bolusGenerics.pHCalibrationData')}}</h3>

        <table v-if="bolus.is_ph" class='ph-config'>
          <tr v-for="config in bolus.bolus_ph_configs" v-bind:key="config.bolus_ph_config_id">
            <td>
              <date-time-picker-with-zone
                @dateChanged="newDate => (config.valid_from = $moment(newDate))"
                :actDate="$moment(config.valid_from)"
              />
            </td>
            <td>
              <v-text-field
                :label="$t('bolusGenerics.fourPh')"
                required
                v-model="config.four_ph_value"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                :label="$t('bolusGenerics.sevenPh')"
                required
                v-model="config.seven_ph_value"
              ></v-text-field>
            </td>
            <td>
              <v-icon class='pointer' @click="deleteConfig(config)">
                delete
              </v-icon>
            </td>
          </tr>
          <tr>
            <td>
              <date-time-picker-with-zone
                @dateChanged="newDate => (newPhConfig.valid_from = $moment(newDate).format())"
                :actDate="newPhConfig.valid_from"
              />
            </td>
            <td>
              <v-text-field
                :label="$t('bolusGenerics.fourPh')"
                required
                v-model="newPhConfig.four_ph_value"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                :label="$t('bolusGenerics.sevenPh')"
                required
                v-model="newPhConfig.seven_ph_value"
              ></v-text-field>
            </td>
          </tr>
        </table>

        <div class="danger-alert" v-if="error">
          {{error}}
        </div>
        <v-layout class="modal-button-row">
          <v-btn
            dark
            block
            class="button-delete button-modal"
            @click="this.delete">
            {{$t('actions.delete')}}
          </v-btn>
          <v-btn
            dark
            block
            class="secondary button-modal"
            @click="save">
            {{$t('actions.saveModifications')}}
          </v-btn>
        </v-layout>
      </v-form>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import BolusApi from "@/api/bolus-api";
import UtilsService from "@/services/UtilsService";

export default {
  props: [
    'clickedId'
  ],
  data () {
    return {
      bolus: {
        bolus_id: null,
        bolus_name: null,
        imei: null,
        imsi: null,
        deveui: null,
        activation_date: null,
        is_ph: null,
        phConfig: null,
        bolus_ph_configs: null
      },
      newPhConfig: {
        four_ph_value: null,
        seven_ph_value: null,
        valid_from: null
      },
      error: null,
      required: (value) => !!value || 'Required.',
      roles: []
    }
  },
  methods: {
    async save () {
      this.error = null
      if (this.$refs.form.validate()) {
        try {
          if (
            this.newPhConfig.four_ph_value &&
            this.newPhConfig.seven_ph_value &&
            this.newPhConfig.valid_from
          ) {
            // to update request
            this.bolus.ph_four_value = this.newPhConfig.four_ph_value;
            this.bolus.ph_seven_value = this.newPhConfig.seven_ph_value;
            this.bolus.ph_valid_from = this.newPhConfig.valid_from;
          }

          const keysToSend = [
            'bolus_id', 'bolus_name',
            'imei', 'imsi',
            'deveui', 'activation_date', 'is_ph',
            'ph_four_value', 'ph_seven_value', 'ph_valid_from'
          ];
          const dataToSend = {};

          keysToSend.forEach((key) => {
            if (this.bolus[key] == undefined || this.bolus[key] == null) {
              return;
            }

            dataToSend[key] = this.bolus[key];
            if ('ph_valid_from' == key) {
              dataToSend[key] = UtilsService.utcDate(this.bolus[key]);
            }

            if(key == 'activation_date'){
              dataToSend[key] = UtilsService.utcDate(this.bolus[key]);
            }

            if (['ph_four_value', 'ph_seven_value'].includes(key)) {
              dataToSend[key] = +this.bolus[key];
            }
          });

          // call put request
          const response = await BolusApi.put(dataToSend);

          if (response.status !== 200) {
            throw ({response});
          }
          
          // reset config fields
          this.newPhConfig = {
            four_ph_value: null,
            seven_ph_value: null,
            valid_from: null
          }
          const bolusID = this.clickedId
          this.fetchBolus(bolusID);

          this.$emit('close')
        } catch (err) {
          console.log(err)
          this.error = err.response.data
        }
      }
    },
    async fetchBolus(bolusID) {
      this.bolus = (await BolusApi.get({bolusID, withBolusPh: true})).data;
    },
    async delete () {
      this.error = null
      try {
        await BolusApi.delete(this.bolus.bolus_id)
        this.$emit('close')
      } catch (err) {
        console.log(err)
        this.error = err.response.statusText
      }
    },
    async deleteConfig(config) {
      try {
        const bolusID = this.clickedId
        await BolusApi.deletePhConfig(config.bolus_ph_config_id)
        this.fetchBolus(bolusID);
      } catch (err) {
        console.log(err)
      }
    }
  },
  watch: {
    clickedId: async function () {
      try {
        const bolusID = this.clickedId
        if(bolusID)
          this.fetchBolus(bolusID);
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style>
.ph-config {
  margin-top: 20px;
}
.ph-config td {
  padding-left: 5px;
  padding-right: 5px;
}
.pointer {
  cursor: pointer;
}
.ph-title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditBolus.vue